<template>
    <div>
        <div class="grid relative">
            <Filters v-if="showFilters" />
            <MonthView />
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useFeedStore } from "@facet/utils/store.js";
import Filters from "@facet/components/Filters.vue";
import MonthView from "@facet/views/MonthView.vue";

const store = useFeedStore();
const { showFilters } = storeToRefs(store);
</script>
